import { IconTable } from '@components/table/IconTable';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { type ProjectData } from 'interfaces/projects/ProjectData.interface';
import { useGetDashboardProjectsTableColumns } from 'pages/DashboardPage/hooks/useGetDashboardProjectTable';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface BestPerformanceProjectsTableProps {
  data?: ProjectData[];
  isFetching?: boolean;
  hoveredId?: number;
  onRowHover: (value: number | undefined) => void;
}

const BestPerformanceProjectsTable: FC<BestPerformanceProjectsTableProps> = ({
  data,
  isFetching = false,
  hoveredId,
  onRowHover,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { columns } = useGetDashboardProjectsTableColumns();
  const { theme } = useTheme();

  const handleOnClickRow = (project: ProjectData): void => {
    if (project.id) {
      navigate(`/app/management/projects/details/${project.id}`);
    }
  };

  return (
    <div className="flex flex-col gap-4" data-testid="performance-table">
      <h3 className="font-bold">{t('dashboardPage.bestPerformance')}</h3>
      <IconTable<ProjectData>
        columns={columns}
        data={data ?? []}
        isFetching={isFetching}
        enableLastColumnClick={true}
        disableHeader={true}
        stripped={true}
        minHeight={150}
        onClickRow={handleOnClickRow}
        onRowHover={onRowHover}
        hoverColor={theme.colors['light-blue']}
        hoveredId={hoveredId}
      />
    </div>
  );
};
export default BestPerformanceProjectsTable;
